var _style, _polyline, _g, _circle, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIllustrationsStep2Updated(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 72 72",
    style: {
      enableBackground: "new 0 0 72 72"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#DADEDE;stroke:#556262;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st1{fill:#2C3838;}\n\t.st2{fill:#556262;}\n\t.st3{fill:#9DA4A4;}\n\t.st4{fill:#DADEDE;}\n\t.st5{fill:#5DD9C5;}\n\t.st6{fill:#18A795;}\n\t.st7{fill:#93FFF8;}\n\t.st8{fill:none;stroke:#9DA4A4;stroke-miterlimit:10;}\n\t.st9{fill:#FFFFFF;stroke:#9DA4A4;stroke-miterlimit:10;}\n\t.st10{fill:none;stroke:#2C3838;stroke-miterlimit:10;}\n\t.st11{fill:#FFFFFF;stroke:#9DA4A4;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st12{fill:#5DD9C5;stroke:#18A795;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st13{fill:none;stroke:#FFFFFF;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st14{fill:#5DD9C5;stroke:#2C3838;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st15{fill:#DADEDE;stroke:#556262;stroke-miterlimit:10;}\n\t.st16{fill:none;stroke:#556262;stroke-miterlimit:10;}\n\t.st17{fill:none;stroke:#FFFFFF;stroke-miterlimit:10;}\n\t.st18{fill:#FFFFFF;}\n\t.st19{fill:#5DD9C5;stroke:#9DA4A4;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st20{fill:none;stroke:#556262;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st21{fill:none;stroke:#556262;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st22{fill:none;stroke:#DADEDE;stroke-miterlimit:10;}\n")), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "22,42.5 51.8,42.5 55.8,26.5 18,26.5 "
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 20,
    y1: 34.5,
    x2: 54,
    y2: 34.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 22.8,
    y1: 26.8,
    x2: 24.8,
    y2: 42.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 29.8,
    y1: 26.8,
    x2: 30.8,
    y2: 42.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 36.5,
    y1: 27,
    x2: 36.5,
    y2: 43
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 43.8,
    y1: 26.8,
    x2: 42.8,
    y2: 42.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 50.8,
    y1: 26.8,
    x2: 48.8,
    y2: 42.8
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st20",
    points: "8.5,20.5 16.8,20.5 22.8,46.5 51.5,46.5  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st21",
    points: "22,42.5 51.8,42.5 55.8,26.5 18,26.5  "
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st16",
    cx: 25.5,
    cy: 52.5,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st22",
    cx: 25.5,
    cy: 52.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st22",
    cx: 48.5,
    cy: 52.5,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st16",
    cx: 48.5,
    cy: 52.5,
    r: 3
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st12",
    cx: 37.5,
    cy: 16.5,
    r: 6
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st13",
    x1: 37.5,
    y1: 14.5,
    x2: 37.5,
    y2: 18.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st13",
    x1: 39.5,
    y1: 16.5,
    x2: 35.5,
    y2: 16.5
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationsStep2Updated);
export default __webpack_public_path__ + "static/media/Illustrations_Step2-Updated.74f56eebe7846dad6ad11f33ae2b4ce5.svg";
export { ForwardRef as ReactComponent };